import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Overline } from "@/components/Reveal";
import { PetitionCTA } from "@/components/PetitionCTA";

const FAQS = [
  {
    q: "Maakt 20 km/u werkelijk verschil?",
    a: "Ja. Bij hogere snelheden speelt band-wegdekgeluid een steeds grotere rol. RIVM-onderzoek laat zien dat rijsnelheid invloed heeft op de geluidemissie. Dat betekent niet dat exact dezelfde reductie op iedere locatie gegarandeerd is — het effect verschilt per situatie.",
  },
  {
    q: "Is 2 dB niet nauwelijks hoorbaar?",
    a: "Een paar decibel klinkt als een klein getal, maar de decibelschaal is logaritmisch. Een reductie van 2 dB betekent ongeveer 37% minder geluidsenergie. Het verschil in ervaren luidheid is niet gelijk aan 37%.",
  },
  {
    q: "Kost dit automobilisten niet veel tijd?",
    a: "Over circa 7 kilometer bedraagt het theoretische verschil tussen 100 en 80 km/u ongeveer één minuut. De werkelijke reistijd is afhankelijk van verkeer en doorstroming.",
  },
  {
    q: "Er ligt toch al stil asfalt?",
    a: "Stiller asfalt is waardevol, maar asfalt en snelheid zijn twee verschillende factoren die de geluidbelasting beïnvloeden. De maatregelen kunnen elkaar aanvullen.",
  },
  {
    q: "Geldt dit ook voor elektrische auto's?",
    a: "Ook elektrische auto's produceren bij hogere snelheid aanzienlijk band- en wegdekgeluid. Het voordeel voor lokale uitlaatgassen en CO₂ is uiteraard anders dan bij auto's met een verbrandingsmotor.",
  },
  {
    q: "Waarom beide rijrichtingen?",
    a: "Omdat omwonenden geluid ontvangen van verkeer in beide richtingen en een structurele maatregel het duidelijkst en meest consequent is als deze voor het gehele traject geldt.",
  },
  {
    q: "Is dit een politieke campagne?",
    a: "Nee. Dit is een burgerinitiatief gericht op een concrete lokale maatregel voor leefbaarheid, geluid en omgeving.",
  },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="scroll-mt-24 border-t border-gooi-green/10 py-24 md:py-32">
    <div className="mx-auto max-w-[90rem] px-5 md:px-12">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <Overline>Bezwaren</Overline>
            <h2 className="mt-4 font-display text-3xl font-medium leading-tight tracking-tight text-gooi-green md:text-5xl">
              Vragen die we vaak horen
            </h2>
            <p className="mt-5 text-base leading-relaxed text-gooi-green/70">
              Redelijke vragen verdienen eerlijke antwoorden. Zonder overdrijving, met bronnen.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible data-testid="faq-accordion">
              {FAQS.map((item, i) => (
                <AccordionItem key={item.q} value={`faq-${i}`} className="border-b border-gooi-green/15">
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="py-6 text-left font-display text-lg font-medium tracking-tight text-gooi-green hover:no-underline md:text-xl"
                  >
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="pb-6 text-base leading-relaxed text-gooi-green/75"
                  >
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
            <div className="mt-10">
              <PetitionCTA location="faq" />
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
